import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  output,
} from '@angular/core';
import { ChevronDownIconComponent } from '@kuiper/icons';
import { LoaderComponent } from '../../../../../ui-components/lib/loader/loader.component';
import {
  InsightChartRow,
  InsightChartRowView,
  toInsightRowViews,
} from '../insight-chart.model';

/**
 * Horizontal bars ranked by value, each with its count and share. Bars are sized against the
 * largest row. When `selectable`, a row emits itself (e.g. to open that entity).
 */
@Component({
  selector: 'lib-ranked-bar-chart',
  imports: [ChevronDownIconComponent, LoaderComponent],
  templateUrl: './ranked-bar-chart.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class RankedBarChartComponent {
  readonly rows = input<InsightChartRow[]>([]);
  readonly loading = input<boolean>(false);
  /** Opt-in: rows become buttons with a chevron that emit `rowSelect`; off, the bars are display-only. */
  readonly selectable = input<boolean>(false);

  readonly rowSelect = output<InsightChartRow>();

  protected readonly rowClass = computed(() =>
    this.selectable()
      ? 'grid-cols-[minmax(6rem,10rem)_minmax(3rem,1fr)_auto_3.5rem_1rem] cursor-pointer hover:bg-neutral-50 focus-visible:ring-2 focus-visible:ring-updated-primary-300'
      : 'grid-cols-[minmax(6rem,10rem)_minmax(3rem,1fr)_auto_3.5rem] cursor-default'
  );

  protected readonly rowViews = computed<InsightChartRowView[]>(() =>
    toInsightRowViews([...this.rows()].sort((a, b) => b.value - a.value))
  );

  select(row: InsightChartRowView): void {
    if (!this.selectable()) {
      return;
    }
    const { key, label, value, color } = row;
    this.rowSelect.emit({ key, label, value, color });
  }
}
